import React from 'react';
import { t, props } from 'tcomb-react';

@props({
  bundle: t.Obj,
  share_purchase_url: t.Str
})
export default class SharePurchase extends React.Component {

  render() {
    const style = {
      'width': '100%',
      'height': '62px'
    };
    return (
      <div className="alert info">
        <strong>{this.props.bundle.title}</strong>
        <iframe scrolling='no' frameBorder='0' src={this.props.share_purchase_url} style={style}></iframe>
      </div>
    );
  }

}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/SharePurchase.js
 **/